import {
  AdminAiAssistantSuggestedAction,
  EmployeeAiAssistantSuggestedAction,
} from "components/AiAssistantComponents/constants";

export const aiAssistantPages = {
  "en-US": {
    admin: {
      ai_assistant_suggested_actions: {
        [AdminAiAssistantSuggestedAction.RUN_NEXT_SCHEDULED_PAYROLL]:
          "Run the next scheduled payroll",
        [AdminAiAssistantSuggestedAction.INCREASE_HOURLY_RATE_FOR_EMPLOYEE]:
          "Increase the hourly rate for my employee",
        [AdminAiAssistantSuggestedAction.ADD_NEW_EMPLOYEE]: "Add a new employee",
      },
      payroll_run: {
        summary: {
          title: "Payroll Details",
          pay_date: "Pay date",
          total_payroll: "Total Payroll",
          debit_date: "Debit date",
          debit_amount: "Debit amount",
          pay_period: "Pay Period",
          number_of_employees: "Number of Employees",
        },
        warnings: {
          title: "Pay attention to the following warnings:",
        },
      },
    },
    employee: {
      ai_assistant_suggested_actions: {
        [EmployeeAiAssistantSuggestedAction.LOG_TIME]: "I want to log time",
      },
    },
    shared: {
      ai_assistant_author_name: "AI Assistant",
      modal: {
        title: "Payroll Assistant",
        new_chat_tooltip: "Start a new chat with the AI assistant",
      },
      chat_input: {
        placeholder: "Ask question...",
      },
    },
  },
};

export default aiAssistantPages;
